import React from 'react'
import { Link } from 'react-router-dom'

class ContentBox extends React.Component {

	render() {
		const { mainSup, mainSub, mainHeading, mainIcon, mainText, headerSub, headerIcon, footerTitle, url, linkTarget, className, image, imageClass, imageAlt } = this.props

		const componentInner = (
			<div className="-inner">
				{ headerSub &&
					<header>
						<span className="-sub">{ headerSub }</span>
					</header>
				}

				{ headerIcon &&
					<header>
						<i className={ headerIcon } aria-hidden="true"></i>
					</header>
				}

				{ ( mainHeading || mainIcon || mainText ) &&
					<main>
						{ mainIcon &&
							<i className={ mainIcon } aria-hidden="true"></i>
						}

						{ mainSup &&
							<span className="-sup" dangerouslySetInnerHTML={ { __html: mainSup } }></span>
						}

						{ mainHeading &&
							<h3 dangerouslySetInnerHTML={ { __html: mainHeading } }></h3>
						}

						{ mainSub &&
							<span className="-sub" dangerouslySetInnerHTML={ { __html: mainSub } }></span>
						}

						{ mainText &&
							<div className="-text" dangerouslySetInnerHTML={ { __html: mainText } }></div>
						}
					</main>
				}

				{ image &&
					<img className={ imageClass } src={ image } alt={ imageAlt } />
				}

				{ footerTitle &&
					<footer>
						<h3 dangerouslySetInnerHTML={ { __html: footerTitle } }></h3>
					</footer>
				}
			</div>
		)

		if ( url ) {
			return (
				<div className={ className + ' content-box' }>
					{ this.props.url.indexOf( '//' ) > -1 &&
						<a href={ this.props.url } target={ linkTarget } rel="noopener noreferrer">
							{componentInner}
						</a>
					||
						<Link to={ this.props.url }>
							{ componentInner }
						</Link>
					}

				</div>
			)
		}
		else {
			return (
				<div className={ className + ' content-box'}>
					{ componentInner }
				</div>
			)
		}
	}
}

ContentBox.defaultProps = {
	url: false,
	linkTarget: '_blank',
	mainHeading: false,
	headerSub: false,
	headerIcon: false,
	footerTitle: false,
	className: '',
	image: false,
	imageClass: '-bg',
	imageAlt: ''
};

export default ContentBox;
